export default __webpack_public_path__ + "static/media/faq.e943e293.png";